"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.informationalMessage = exports.showChat = exports.hideChat = exports.siigoStylesChat = void 0;
var utils_1 = require("../utils");
var constants_1 = require("./constants");
var events_1 = require("./events");
require("./suscriptions");
var events = require("./events");
function siigoStylesChat() {
    var five9Header = (0, utils_1.documentElementByClass)("five9-header");
    var closeButton = (0, utils_1.documentElementByClass)("close-five9");
    if (!closeButton) {
        var newCloseButton = document.createElement("div");
        newCloseButton.classList.add("close-five9");
        newCloseButton.innerHTML = "X";
        newCloseButton.addEventListener("click", hideChat);
        if (five9Header) {
            five9Header.appendChild(newCloseButton);
        }
    }
    var five9MinimizeButton = (0, utils_1.documentElementByIdNode)("five9-minimize-button");
    if (five9MinimizeButton) {
        five9MinimizeButton.classList.remove("five9-chat-button");
        five9MinimizeButton.classList.add("five9-chat-button-siigo-minimize");
        five9MinimizeButton.addEventListener("click", function () {
            return events.dispatchChatEvent(events.MINIMIZE_FIVE9_CHAT_EVENT);
        });
        var five9Text = five9MinimizeButton.querySelector(".five9-text");
        if (five9Text)
            five9Text.innerHTML = "";
    }
    var five9MinimizeIcon = (0, utils_1.documentElementByIdNode)("five9-minimize-icon");
    if (five9MinimizeIcon)
        five9MinimizeIcon.innerHTML = "<div class='f9 minimize-icon'></div>";
    var five9MaximizeButton = (0, utils_1.documentElementByIdNode)("five9-maximize-button");
    if (five9MaximizeButton) {
        five9MaximizeButton.classList.remove("five9-chat-button");
        five9MaximizeButton.classList.add("five9-chat-button-siigo-maximize");
        var five9Icon = five9MaximizeButton.querySelector(".five9-icon");
        if (five9Icon) {
            five9Icon.classList.remove("five9-icon");
            five9Icon.classList.add("five9-icon-siigo");
            five9Icon.innerHTML = "<i class='f9 icon-siigo-comunicacion-chat'></i>";
            five9MaximizeButton.addEventListener("click", function () {
                return events.dispatchChatEvent(events.MAXIMIZE_FIVE9_CHAT_EVENT);
            });
        }
        var five9Text = five9MaximizeButton.querySelector(".five9-text");
        if (five9Text)
            five9Text.innerHTML = "";
    }
    var fillLogo = (0, utils_1.documentElementByClass)("fill-logo");
    if (fillLogo) {
        var logoImg = fillLogo.querySelector("img");
        if (logoImg)
            logoImg.classList.add("mt4");
    }
    var emailButton = (0, utils_1.documentElementByIdNode)("redirect-email-button");
    if (emailButton)
        emailButton.innerHTML = "Comenzar chat";
    var popup = (0, utils_1.documentElementByIdNode)("five9-popout-button");
    if (popup)
        popup.remove();
    var profilesLabel = (0, utils_1.documentElementByIdNode)("profiles-label");
    if (profilesLabel)
        profilesLabel.innerHTML = "Perfil";
    var header = document.querySelector("head");
    var existStyle = (0, utils_1.documentElementByClass)("five9-custom-styles");
    if (!existStyle) {
        var styles = document.createElement("style");
        styles.classList.add("five9-custom-styles");
        styles.innerHTML = "\n    .ui-logo {\n      padding-top: 5px;\n      padding-bottom: 0;\n    } \n    .ui-header .ui-logo img {\n      height: 30px;\n    }\n    .hideChat {\n      display:none !important;\n    }";
        if (header)
            header.appendChild(styles);
    }
    if (emailButton)
        emailButton.innerHTML = "Enviar email";
    var maximizeButton = (0, utils_1.documentElementByIdNode)("five9-maximize-button");
    if (maximizeButton)
        maximizeButton.click();
}
exports.siigoStylesChat = siigoStylesChat;
function hideChat() {
    if ((0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.status) ===
        constants_1.SUCCESS_CLOSED_FIVE9_SURVEY) {
        (0, utils_1.removeLocalStorage)(utils_1.LOCAL_STORAGE_FIVE9_ITEM);
        (0, events_1.dispatchChatEvent)(events_1.CLOSE_FIVE9_CHAT_EVENT);
    }
    var chat = (0, utils_1.documentElementByClass)("five9-frame");
    if (chat)
        chat.classList.add("hideChat");
}
exports.hideChat = hideChat;
function showChat() {
    var chat = (0, utils_1.documentElementByClass)("five9-frame");
    if (chat && chat.classList.contains("hideChat"))
        chat.classList.remove("hideChat");
}
exports.showChat = showChat;
function informationalMessage(message) {
    var activeMessageUrls = utils_1.COUNTRY_URLS.COLOMBIA_SIIGO_NUBE.concat(utils_1.COUNTRY_URLS.CONTIFICO, utils_1.COUNTRY_URLS.COLOMBIA_SIIGO);
    if ((0, utils_1.validateUrl)(activeMessageUrls)) {
        var frameFull = (0, utils_1.documentElementByIdNode)(constants_1.ID_FIVE9_FRAME_FULL);
        var head = document.getElementsByTagName("HEAD")[0];
        var styleMessageFrameFull = document.createElement("style");
        var bottomFive9 = utils_1.CSS_STYLES.BOTTOM_INFORMATIONAL_MESSAGE.MINIMUM;
        if (message.length > utils_1.CSS_STYLES.BOTTOM_INFORMATIONAL_MESSAGE.BASE_CHARACTERS) {
            var numberOfLines = message.length /
                utils_1.CSS_STYLES.BOTTOM_INFORMATIONAL_MESSAGE.BASE_CHARACTERS;
            bottomFive9 +=
                numberOfLines * utils_1.CSS_STYLES.BOTTOM_INFORMATIONAL_MESSAGE.UP_SIZE;
        }
        styleMessageFrameFull.innerHTML = "\n      .top-message {\n        color: white;\n        padding: 10px;\n        margin-bottom: 10px;\n        border-radius: 10px; \n      }\n\n      .top-message-siigo {\n        position: absolute;\n        right: 330px;\n        width: 266px;\n      }\n      \n      .top-message-contifico {\n        position: absolute;\n        left: 330px;\n        width: 266px;\n      }\n\n      .background-color-siigo {\n        background-color: #00aaff;\n      }\n\n      .background-color-contifico {\n        background-color: #2063f1;\n      }\n      \n      .five9-frame-full-message {\n        bottom: ".concat(bottomFive9, "px !important;\n      }\n  \n      .five9-minimize-button-message {\n        top: 158px !important;\n      }\n    ");
        var five9MinimizeButton = document.getElementById("five9-minimize-button");
        var divMessage = document.createElement("div");
        divMessage === null || divMessage === void 0 ? void 0 : divMessage.classList.add("top-message");
        head.appendChild(styleMessageFrameFull);
        divMessage.innerHTML = message;
        if ((0, utils_1.validateUrl)(utils_1.COUNTRY_URLS.COLOMBIA_SIIGO)) {
            divMessage === null || divMessage === void 0 ? void 0 : divMessage.classList.add("background-color-siigo");
            divMessage === null || divMessage === void 0 ? void 0 : divMessage.classList.add("top-message-siigo");
            frameFull === null || frameFull === void 0 ? void 0 : frameFull.insertBefore(divMessage, frameFull.firstChild);
        }
        else if ((0, utils_1.validateUrl)(utils_1.COUNTRY_URLS.COLOMBIA_SIIGO_NUBE)) {
            divMessage === null || divMessage === void 0 ? void 0 : divMessage.classList.add("background-color-siigo");
            five9MinimizeButton === null || five9MinimizeButton === void 0 ? void 0 : five9MinimizeButton.classList.add("five9-minimize-button-message");
            frameFull === null || frameFull === void 0 ? void 0 : frameFull.classList.add("five9-frame-full-message");
            frameFull === null || frameFull === void 0 ? void 0 : frameFull.insertBefore(divMessage, frameFull.lastChild);
        }
        else if ((0, utils_1.validateUrl)(utils_1.COUNTRY_URLS.CONTIFICO)) {
            divMessage === null || divMessage === void 0 ? void 0 : divMessage.classList.add("background-color-contifico");
            divMessage === null || divMessage === void 0 ? void 0 : divMessage.classList.add("top-message-contifico");
            frameFull === null || frameFull === void 0 ? void 0 : frameFull.insertBefore(divMessage, frameFull.firstChild);
        }
    }
}
exports.informationalMessage = informationalMessage;
//# sourceMappingURL=styles.js.map